export default __webpack_public_path__ + "static/media/questionmark.5d57b1bb.jpg";